module.exports = __webpack_public_path__ + "sideSprite-6ec98da01d6df940b669eedcc0357f93.png";